import { Grid, Stack, Title } from "@mantine/core";
import { SourceCard } from "./SourceCard";
import { Delta, Source } from "../../api";

export interface CitationListProps {
    sources: Source[];
    onSourceClick: (source: Source, anchor: string) => void;
    response: Delta | undefined;
}

export const CitationList = ({ sources, onSourceClick, response }: CitationListProps) => {
    if (sources.length === 0) {
        return null;
    }

    return (
        <Stack gap="md">
            <Title order={6}>Citations ({sources.length})</Title>

            <Grid overflow="hidden">
                {sources.map((source, index) => (
                    <Grid.Col key={index} span={{ base: 12, sm: 6, md: 4, lg: 3 }}>
                        <SourceCard source={source} number={index + 1} response={response} onClick={onSourceClick} />
                    </Grid.Col>
                ))}
            </Grid>
        </Stack>
    );
};
